import styled from "styled-components";

export const ModalContainer = styled.div``;

export const ModalTitle = styled.span`
  color: #43474a;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
`;

export const Conten = styled.div`
  margin: 0;

  .modal-header {
    background-color: #94e8e8;
    border-radius: 24px 24px 0 0;
    padding: 0;
    height: 90px;
  }

  .header-container {
    margin: 27px 10px 27px 49px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .modal-header .close {
    margin: 27px;
  }

  .modal-body {
    padding: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    margin-top: 51px;
  }

  span {
    color: #292929;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 66.667% */
    letter-spacing: 1.2px;
    margin-top: 48px;
    margin-bottom: 16px;
  }

  .term-accepted {
    margin-bottom: 150px; 
  }

  p {
    color: #43474a;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    padding: 0 71px 58px 81px;
  }
`;
